import React from 'react';
import { Form, Input, Row, Col, message, Spin } from 'antd';
import ApiService from '../../actions/apiService';
import 'react-flags-select/css/react-flags-select.css';

const FormItem = Form.Item;
const { TextArea } = Input;
const initialState = {
  form: {
    firstName: '',
    lastName: '',
    billingAddress1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    phone: '',
    cellphoneAlerts: '',
  },
  error: '',
  success: ''
}

class UserProfileForm extends React.Component {
  
  state = {
    error: initialState.error,
    success: initialState.success,
    isLoading: true,
    profileData: {},
  }
  
  async componentWillMount() {
    const profileData = await ApiService.getProfile();
    this.setState({
      isLoading: false,
      profileData: profileData || {},
    }, () => {
      if (profileData) {
        this.props.form.setFieldsValue({
          firstName: profileData.firstName,
          lastName: profileData.lastName,
          billingAddress1: profileData.billingAddress1,
          billingAddress2: profileData.billingAddress2,
          city: profileData.city,
          state: profileData.state,
          zip: profileData.zip,
          phone: profileData.phone,
          country: profileData.country
        })
      }
    })
  }
  
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const data = {
          ...(this.state.profileData || {}),
          firstName: values.firstName,
          lastName: values.lastName,
          billingAddress1: values.billingAddress1,
          billingAddress2: values.billingAddress2,
          city: values.city,
          state: values.state,
          zip: values.zip,
          phone: values.phone,
          country: values.country,
        };
        const profileData = await ApiService.postProfile(data);
        if (profileData && profileData.status === 200) {
          message.success('Profile saved successfully!');
        } else {
          message.error('Something went wrong!');
        }
      }
    })
  }
  
  render() {
    const { getFieldDecorator } = this.props.form;
    if (this.state.isLoading) {
      return (
        <div style={{textAlign: 'center', marginTop: 50, width: '100%'}}>
          <Spin/>
        </div>
      );
    }
    
    return (
          <Row gutter={16}>
            <Col span={16}>
              <Form layout={'vertical'} onSubmit={this.handleSubmit}>
                <FormItem label="First Name">
                  {getFieldDecorator('firstName', {
                    rules: [{
                      required: true,
                      message: 'Please input your first name!',
                      whitespace: true
                    }],
                  })(
                    <Input placeholder="Input first name"/>
                  )}
                </FormItem>
                <FormItem label="Last Name">
                  {getFieldDecorator('lastName', {
                    rules: [{
                      required: true,
                      message: 'Please input your last name!',
                      whitespace: true
                    }],
                  })(
                    <Input placeholder="Input Last Name "/>
                  )}
                </FormItem>
                
                <FormItem label="Billing Address 1">
                  {getFieldDecorator('billingAddress1', {
                    rules: [{
                      required: true,
                      message: 'Please input your billing address 1!',
                      whitespace: true
                    }],
                  })(
                    <TextArea placeholder="Input billing address 1" autosize={{maxRows: 3}}/>
                  )}
                </FormItem>
                
                <FormItem label="Billing Address 2">
                  {getFieldDecorator('billingAddress2', {
                    rules: [{
                      message: 'Please input your billing address 2!',
                      whitespace: true
                    }],
                  })(
                    <TextArea placeholder="Input billing address 2" autosize={{maxRows: 3}}/>
                  )}
                </FormItem>
                
                <Row gutter={16}>
                  <Col span={8}>
                    <FormItem label="City">
                      {getFieldDecorator('city', {
                        rules: [{
                          required: true,
                          message: 'Please input your city name!',
                          whitespace: true
                        }],
                      })(
                        <Input placeholder="Input city name"/>
                      )}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label="State">
                      {getFieldDecorator('state', {
                        rules: [{
                          required: true,
                          message: 'Please input your state name!',
                          whitespace: true
                        }],
                      })(
                        <Input placeholder="Input state name"/>
                      )}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label="Zip">
                      {getFieldDecorator('zip', {
                        rules: [
                          {
                            pattern: '^(0|[1-9][0-9]*)$',
                            message: 'Please input only numbers values!',
                          }, {
                            required: true,
                            message: 'Please input your zip code!',
                            whitespace: true
                          }],
                      })(
                        <Input placeholder="Input zip code"/>
                      )}
                    </FormItem>
                  </Col>
                </Row>
                
                {/*<Row gutter={16}>*/}
                  {/*<Col sm={24} xs={24}>*/}
                  {/*<FormItem label="Country">*/}
                    {/*{getFieldDecorator('country', {*/}
                      {/*rules: [{*/}
                        {/*message: 'Please input your country name!',*/}
                        {/*whitespace: true*/}
                      {/*}],*/}
                    {/*})(*/}
                      {/*<Input placeholder="Input country name"/>*/}
                    {/*)}*/}
                  {/*</FormItem>*/}
                  {/*</Col>*/}
                {/*</Row>*/}
                
                <Row gutter={16}>
                  <Col sm={12} xs={24}>
                    <FormItem
                      label="Phone">
                      {getFieldDecorator('phone', {
                        rules: [{
                          pattern: '^(0|[1-9][0-9]*)$',
                          message: 'Please input only numbers values!',
                        }, {
                          required: true,
                          message: 'Please input your phone number!',
                          whitespace: true
                        }],
                      })(
                        <Input placeholder="Input phone number"/>
                      )}
                    </FormItem>
                  </Col>
                  <Col sm={12} xs={24}>
                  
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col sm={24} style={{textAlign: 'right'}}>
                    <button type="submit" style={{width: '200px', background: '#3190ff', color: '#fff'}} className="ant-btn ant-btn-submit">Save</button>
                  </Col>
                </Row>
              </Form>
            
            </Col>
          </Row>
    );
  }
}

const UserProfile = Form.create()(UserProfileForm);
export default UserProfile



// WEBPACK FOOTER //
// ./src/components/user-profile/UserProfile.js